import React from 'react'
import { Modal } from '../ecosystem'


const OnboardingDashboardModal = (props) => {

    const { isOpen, onDismiss, onStarted } = props;

    return (
        <Modal isOpen={isOpen} icon="mybsw"
            modalHeader={"Welcome to your health hub"}
            modalBody={"Hey, we’ve remodeled! Would you like a tour of our new features?"}
            modalFooterButtons={[
                { variant: 'secondary', label: 'No Thanks', onClick: () => { onDismiss(); } },
                { label: 'Yes, Get Started', onClick: () => { onStarted(); } }
            ]} />
    )
}

export default OnboardingDashboardModal